import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import SingleOrder from "../components/orderHistory/SingleOrder";
import SuppliersInfo from "../components/infoScreens/SuppliersInfo";

export default function SuppliersInfoView() {
  return (
    <div className="pageWrapper">
      <Header title="Over De Boer" />
      <div className="contentWrapper fadeInDelayed">
        <SuppliersInfo />
      </div>
      <BottomNavBar />
    </div>
  );
}
